import { queryNumber } from "@/api/personalCenter.js"
export default {
	data () {
		return {

			userName: '',
			lotteryNo: '',

			select: {
				value: 0,
				arr: [
					{ label: '免费', value: 0 },
				]
			},

			lingshiFile: {
				img: '',
				excel: '',
				txt: ''
			},

			remark: ''
		}
	},
	mounted () {
		let userName = localStorage.getItem('userInfo');
		this.userName = userName ? JSON.parse(userName).username : '';

		this.getLotteryNo()

		// 1-100缩币
		for (let i = 1; i <= 100; i++) { this.select.arr.push({ label: `${i}缩币`, value: i }) }

	},
	methods: {
		getLotteryNo () {
			// 获取当前彩种最新期号
			queryNumber(this.lotteryType-1).then(res => this.lotteryNo = res.data.next)
		},
		confimAdd () {
			let { img, excel, txt } = this.lingshiFile
			console.log('img', img);
			console.log('excel', excel);
			console.log('txt', txt);
			if (!img) { this.$message.error('请选择截图'); return }
			if (!excel) { this.$message.error('请选择excel'); return }
			if (!txt) { this.$message.error('请选择txt'); return }

			console.log('可以添加');

			this.table[this.radio].push(this.lingshiFile)

			this.$refs.img.value = ''
			this.$refs.excel.value = ''
			this.$refs.txt.value = ''

			this.lingshiFile = {}

		},
		chooseFile (type) {
			console.log(type);
			let resultFile = this.$refs[type].files[0]
			// console.log('resultFile', resultFile);

			const formData = new FormData();
			formData.append("file", resultFile);
			this.$http.post('/uploadUtil', formData).then(res => {
				this.lingshiFile[type] = res.message
			})
		},
		itemDelete (type, index) {
			this.table[type].splice(index, 1)
		},
		// 确认发布
		confirmRelease () {
			this.$http.post('/create/excel/publish', {
				userId: JSON.parse(localStorage.getItem('userInfo')).userId,
				lotteryType: this.lotteryType,
				url: JSON.stringify(this.table),
				remark: this.remark,
				currency: this.select.value,	//缩币
				lottery_no: this.lotteryNo,	//期号
			}).then(res => {
				console.log(res);
				this.$message({
					message: res.message,
					type: 'success'
				});
			})
		}
	},
}